var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#id-1a)" },
      React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 3.92188C15.5509 3.92188 14.6408 4.29889 13.9697 4.96997L12.9753 5.96433C12.9734 5.96618 12.9715 5.96804 12.9697 5.96991C12.9678 5.97179 12.9659 5.97367 12.9641 5.97556L3.46967 15.47C3.32902 15.6106 3.25 15.8014 3.25 16.0003V20.0003C3.25 20.4145 3.58579 20.7503 4 20.7503H8C8.19891 20.7503 8.38968 20.6713 8.53033 20.5306L19.0303 10.0306C19.7014 9.35955 20.0784 8.44936 20.0784 7.5003C20.0784 6.55124 19.7014 5.64106 19.0303 4.96997C18.3592 4.29889 17.4491 3.92188 16.5 3.92188ZM13.5 7.56093L4.75 16.311V19.2503H7.68934L16.4394 10.5003L13.5 7.56093ZM17.5 9.43961L17.9697 8.96997C18.3595 8.58019 18.5784 8.05154 18.5784 7.5003C18.5784 6.94907 18.3595 6.42041 17.9697 6.03063C17.5799 5.64085 17.0512 5.42188 16.5 5.42188C15.9488 5.42188 15.4201 5.64085 15.0303 6.03063L14.5607 6.50027L17.5 9.43961Z", fill: "#303030" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "id-1a" },
        React.createElement("path", { fill: "#fff", d: "M0 0H24V24H0z" })
      )
    )
  );
});